import React from 'react'

function ViewDocumentimage() {
  return (
    <div>ViewDocumentimage</div>
  )
}

export default ViewDocumentimage